export const BASE_URL =  window.location.origin === 'https://game.twotwentyk.io' ? 'https://api.twotwentyk.io/api' : 'https://stage.twotwentyk.io/api';

export const dashboardUrls = {
  packs: '/card_collection/list_card_collections/params?limit=100&offset=0',
  predictions: '/me/nft_card_prediction/',
  identities: '/me/nft_card_identity/'
}

export const datesUrls = {
  items: '/me/nft_card_date/',
  filters: '/me/list_filters/params?type=dates',
}

export const categoriesUrls = {
  items: '/me/nft_card_category/',
  filters: '/me/list_filters/params?type=categories',
}

export const identitiesUrls = {
  items: '/me/nft_card_identity/',
  filters: '/me/list_filters/params?type=identities',
}

export const eventsUrls = {
  items: '/me/nft_card_event_date/',
  filters: '/me/list_filters/params?type=events',
}

export const triggersUrls = {
  items: '/me/nft_card_trigger/',
  filters: '/me/list_filters/params?type=triggers',
}

export const prizesUrls = {
  items: '/me/nft_card_prize/',
  filters: '/me/list_filters/params?type=prizes',
}

export const predictionsUrls = {
  items: '/me/nft_card_prediction/',
  filters: '/me/list_filters/params?type=predictions',
}

export const cardPacksUrls = {
  items: '/me/card_pack/',
  filters: '/me/list_filters/params?type=cardpacks',
}

export const marketplaceCardsUrls = {
  items: '/me/marketplace_cards/',
  filters: '/me/list_filters/params?type=marketplaceCards',
}

export const marketplaceCardPacksUrls = {
  items: '/me/marketplace_card_packs/',
  filters: '/me/list_filters/params?type=marketplaceCardpacks',
}

export const buypacksUrls = {
  items: '/card_collection/list_card_collections/',
  filters: '/me/list_filters/params?type=cardpacks'
}

export const getUrlByPathname = (pathname) => {
  if (pathname.includes('/dashboard')) {
    return dashboardUrls
  } else if (pathname.includes('/dates')) {
    return datesUrls;
  } else if (pathname.includes('/categories')) {
    return categoriesUrls;
  } else if (pathname.includes('/identities')) {
    return identitiesUrls
  } else if (pathname.includes('/events')) {
    return eventsUrls
  } else if (pathname.includes('/triggers')) {
    return triggersUrls
  } else if (pathname.includes('/prizes')) {
    return prizesUrls
  } else if (pathname.includes('/predictions')) {
    return predictionsUrls
  } else if (pathname.includes('/inventory/card-packs')) {
    return cardPacksUrls
  } else if (pathname.includes('/marketplace/cards')) {
    return marketplaceCardsUrls
  } else if (pathname.includes('/marketplace/card-packs')) {
    return marketplaceCardPacksUrls
  } else if (pathname.includes('/buypacks')) {
    return buypacksUrls
  }
}
